<template>
  <v-dialog v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on">Agregar Factura</v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-model="selected"
        show-select
        single-select
        selectable-key="id"
        :headers="headers"
        :items="facturas"
        :search="search"
      ></v-data-table>
      <v-card-actions>
          <v-btn @click="volver">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      facturas: [],
      selected: [],
      showDialog: false,
      search: "",
      headers: [
        {
          text: 'Descripcion',
          align: 'left',
          filterable: false,
          value: 'descripcion'
        },
        { text: 'NroFactura', value: 'codDocumento' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Cliente', value: 'cliente' },
        { text: 'Exentas', value: 'exentas' }
      ]
    }
  },
  mounted() {
    axios
      .get("/gestion/facturas")
      .then((res) => {
        this.facturas = res.data;
      })
      .catch((err) => console.log(err));
  },
  methods: {
      volver() {
          if (this.selected.length == 1) {
              this.$emit("facturaSeleccionada", this.selected[0])
          }
          this.showDialog = false
      }
  }
};
</script>